import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, TransactionalSubheader, SelectButton, Card } from "iuvity-ui-components";
import { Header } from "../../components";
import { AppContext } from "../../context/index";
import { usePointOfAttention } from "../../hooks/usePointsOfAttention";
import { usePointsParams } from "../../hooks/usePointsParams";
import { useServices } from "../../hooks/useServices";
import { useSchedules } from "../../hooks/useSchedules";
import {
    CustomDialog,
    DialogProps,
  } from "../../components/dialog/CustomDialog";
import { CustomDetailBox } from "../../components/points/CustomDetailBox";
import { basicInfoBoxFields } from "../../constants";
import { locationBoxFields } from "../../constants";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { formatHour12 } from "../../helpers/formatDate";
import { FileUpload } from 'primereact/fileupload';
import { formatStringToDate } from "../../helpers/formatDate";

export const DetailPointsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
      t,
      appState: { user, selectedPointsObject },
      setAppState,
    } = useContext(AppContext);
  
    const { pointOfAttentionAction } = usePointOfAttention("ID");
    const { listDepartments } = usePointsParams();
    const { dataService } = useServices("DATA");
    const { dataSchedule } = useSchedules("DATA", "no-translate");
    const [modalProps, setModalProps] = useState<DialogProps>({
      visible: false,
    } as DialogProps);
    const [services, setServices] = useState<any>([])
    const [schedules, setSchedules] = useState<any>([])
  
    const onReturn = () => {
      setAppState((prev) => ({
        ...prev,
        selectedPointsObject: null,
      }));
      navigate(-1);
      window.scrollTo(0, 0);
    };
  
    const onEdit = () => {
      navigate("/pointsofattention/editpointofattention");
    };
  
    const onDelete = async () => {
      const actionStatus = await pointOfAttentionAction(
        "DELETE",
        selectedPointsObject?.id
      );
      if (actionStatus === "SUCCESS") navigate(-1);
    };
  
    const handleModalProps = () => {
      setModalProps((prev) => ({
        ...prev,
        visible: true,
        title: t("PointsOfAttention.deleteModalPointsTitle"),
        content: `${t("PointsOfAttention.deleteModalPointsContent1Label")} "${
          selectedPointsObject?.name
        }" ${t("PointsOfAttention.deleteModalPointsContent2Label")}`,
        onConfirm: () => onDelete(),
      }));
    };

    useEffect(()=>{
        if (dataService && dataService.length > 0) {
            setServices(dataService?.filter((item:any)=>selectedPointsObject?.serviceIds.includes(item.id)))
        }
    },[dataService])

    useEffect(()=>{
      if (dataSchedule && dataSchedule.length > 0) {
          setSchedules(dataSchedule?.filter((item:any)=>selectedPointsObject?.scheduleIds.includes(item.id)))
      }
  },[dataSchedule])

    // DAYS-SELECTBUTTON
    const [valueDays, setValueDays] = useState(null);
    const [schedulesToShow, setSchedulesToShow] = useState<any>([]);
    const items = [
      { name: t('PointsOfAttention.dayMONDAY').slice(0,2), value: 'MONDAY' },
      { name: t('PointsOfAttention.dayTUESDAY').slice(0,2), value: 'TUESDAY' },
      { name: t('PointsOfAttention.dayWEDNESDAY').slice(0,2), value: 'WEDNESDAY' },
      { name: t('PointsOfAttention.dayTHURSDAY').slice(0,2), value: 'THURSDAY' },
      { name: t('PointsOfAttention.dayFRIDAY').slice(0,2), value: 'FRIDAY' },
      { name: t('PointsOfAttention.daySATURDAY').slice(0,2), value: 'SATURDAY' },
      { name: t('PointsOfAttention.daySUNDAY').slice(0,2), value: 'SUNDAY' }
    ];
  
    return (
    <>
        {/* <Header
          welcomeMessage={t("Dashboard.welcomeTitle")}
          userName={user?.name}
        /> */}
  
        <TransactionalSubheader
          subheaderTitle={
            <div style={{ position: "relative", left: "-40px" }}>
              <i
                className="iu iu-icon-left pr-3"
                onClick={onReturn}
                aria-hidden="true"
                style={{
                  fontSize: "var(--font-size-tablet-title)",
                  cursor: "pointer",
                }}
              />
              {t("PointsOfAttention.detailTitle")}
            </div>
          }
        >
          <TransactionalSubheader.BreadCrumb
            id={t("PointsOfAttention.detailTitle")}
            disabledDefaultHome={true}
            breadcrumbsHomeItem={{
              icon: "iu iu-icon-home",
              command: () => navigate('/'),
            }}
            breadcrumbsItems={[
              {
                label: t("PointsOfAttention.pointsTitle"),
                command: () => onReturn(),
              },
              {
                label: t(`PointsOfAttention.detailPointOfAttentionBreadcrumb`),
                style: { fontFamily: "var(--fontBarlowSemiBold)" },
                disabled: true
              },
            ]}
          />
          <TransactionalSubheader.Title />
        </TransactionalSubheader>
  
        {/* Caja de Información Básica */}
        <CustomDetailBox
            boxTitle={t('PointsOfAttention.basicInfoTitle')}
            fields={basicInfoBoxFields}
            data={{
              ...selectedPointsObject,
              description: selectedPointsObject?.observation,
              startDate: formatStringToDate(selectedPointsObject?.startDate, true, t),
              endDate: formatStringToDate(selectedPointsObject?.endDate, true, t),
            }}
        />
  
        {/* Caja de Ubicación */}
        <CustomDetailBox
            boxTitle={t('PointsOfAttention.locationTitle')}
            fields={locationBoxFields}
            data={selectedPointsObject}
        />

        {/* Caja de Servicios */}
        <div className="services-box flex flex-column justify-content-center mt-4">
            <div className="flex justify-content-center">
                <div className="picklist-points--view__title pl-8" style={{ marginLeft: 'var(--space-xxl)', width: '80rem' }}>
                    <p className="boxTitle">
                        {t('PointsOfAttention.servicesTabTitle')}
                    </p>
                    <div className="spicklist-points--view__subtitle pr-6">
                      <p className="boxSubtitle" style={{marginTop: '1.5rem'}}>
                          {t('PointsOfAttention.servicesComponentDescription')}
                      </p>
                    </div>
                </div>
            </div>
            <div className="flex justify-content-center" style={{ width: '100%' }}>
                <div
                    className="flex justify-content-center"
                    style={{
                        width: 'calc(var(--breakpoint-sm) - 3.5rem)'
                    }}
                >
                    <div
                        id="pick-list-view"
                        className="p-picklist p-component picklist-points--view__component mt-4"
                        style={{
                            width: '100%'
                        }}
                    >
                        <div className="p-picklist-list-wrapper p-picklist-target-wrapper">
                            <div className="p-picklist-header">{t("PointsOfAttention.selectedServicesPickLabel")}</div>
                            <ul
                                className="p-picklist-list p-picklist-target"
                                role="listbox"
                                aria-multiselectable="true"
                                style={{
                                    width: '100%',
                                }}
                            >
                                    <PerfectScrollbar>
                                        {
                                            services?.map((service:any)=>(
                                                <li className="p-picklist-item" role="option" aria-selected="false">
                                                    <article className="product-item">
                                                        <p>{service.name}</p>
                                                    </article>
                                                </li>
                                            )) 
                                        }
                                    </PerfectScrollbar>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Caja de Horarios */}
        <div className="schedules-points mt-4">
          <div className="schedules-points--container">
            <div className="schedules-points--container__title">
                <p className="boxTitle">
                    {t('PointsOfAttention.schedulesTabTitle')}
                </p>
                <div className="schedules-points--container__subtitle">
                  <p className="boxSubtitle" style={{marginTop: '1.5rem'}}>
                      {t('PointsOfAttention.schedulesDetailComponentDescription')}
                  </p>
              </div>
            </div>
            <div>
            <div className={`container-treeboxes schedules-points--view-box-two mt-4`} id='PreparationFormContainer'>
              <div className={`treeboxes-child general-form mid schedules-points--view-box-two__selectdays`}>
                <div
                  className="treeboxes-item tabletsecond treeboxes-item__white"
                  id='SelectScheduleContainer'
                  style={{ borderRadius: '8px' }}
                >
                  <div className="schedules-days-container">
                    <SelectButton
                      value={valueDays}
                      onChange={(e) => {
                        setValueDays(e.value)
                        setSchedulesToShow(schedules.filter((item:any) => e.value === item.day))
                      }}
                      optionLabel="name"
                      options={items}
                    />
                  </div>
                  <div className="schedules-scrollbar" style={{ height: '80%' }}>
                    <PerfectScrollbar>
                      {
                        schedulesToShow.map((schedule:any)=>(
                          <div className="flex mb-1">
                            <Card
                              key={schedule.id}
                            >
                                <p>
                                  {localStorage.getItem('LANGUAGE') === 'es' && 'Horario '}
                                  {t(`PointsOfAttention.typeOfSchedule${
                                      schedule.scheduleType.name === 'NORMAL'
                                      ? 'REGULAR'
                                      : schedule.scheduleType.name}`)}
                                  {localStorage.getItem('LANGUAGE') === 'en' && ' schedule'}
                                </p>
                                <p>{`${formatHour12(schedule.scheduleTimes[0].start)} - ${formatHour12(schedule.scheduleTimes[0].end)}`}</p>
                            </Card>
                          </div>
                        ))
                      }
                    </PerfectScrollbar>
                  </div>
                </div>
              </div>
          </div>
            </div>
          </div>
        </div>

      {/* Caja de carga de Imágenes */}
      <div className="schedules-points--fileupload mt-4">
        <div className="schedules-points--fileupload-container px-5">
          <div className="schedules-points--container__title">
              <p className="boxTitle">
                {t('PointsOfAttention.iconPointLabel')}
              </p>
          </div>
          <div className="card mt-4">
            <FileUpload
              accept="image/*"
              // maxFileSize={1000000}
              headerTemplate={<></>}
              emptyTemplate={
                (selectedPointsObject?.layerName !== '' && selectedPointsObject?.layerSize !== '')
                ?
                  <div
                    className="flex align-items-center pl-3"
                    style={{
                      height: '100%',
                      justifyContent: 'space-around',
                    }}
                  >
                    <div
                      style={{
                        height: '80%',
                        backgroundColor: 'var(--cardBackgroundColorTwoShade20)',
                        width: 'var(--space-xxxl)',
                        borderRadius: '0.25rem',
                      }}
                    />
                    <div>
                      {selectedPointsObject?.layerName}
                    </div>
                    <div>
                      {selectedPointsObject?.layerSize}
                    </div>
                  </div>
                : <></>
              }
            />
          </div>
        </div>    
      </div>
  
        {/* Buttons */}
        <div className="create-points-buttons">
          <div
            className="ap-selector-btn-c my-5 gap-5 create-points-buttons__button-container px-5"
          >
            <Button
              variant="p-button-link"
              label={t("PointsOfAttention.deleteBtnLabel")}
              onClick={() => handleModalProps()}
            />
            <Button
              variant="p-button"
              label={t("PointsOfAttention.editBtnLabel")}
              disabled={false}
              onClick={onEdit}
            />
          </div>
        </div>
  
        <CustomDialog
          title={modalProps.title}
          visible={modalProps.visible}
          content={modalProps.content}
          handleModalState={setModalProps}
          onConfirm={modalProps.onConfirm}
        />
      </>
    );
  };
  